import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

firebase.initializeApp({
  projectId: process.env.FIREBASE_PROJECT_ID,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  apiKey: process.env.FIREBASE_API_KEY,
});

export const db = firebase.database().ref();
export const Timestamp = firebase.database.ServerValue.TIMESTAMP;

firebase.auth().signInWithEmailAndPassword(
  process.env.FIREBASE_ADMIN_EMAIL,
  process.env.FIREBASE_ADMIN_PASSWORD,
).catch(error => {
  // eslint-disable-next-line
  console.log(`${error.code} : ${error.message}`)
});


// WEBPACK FOOTER //
// ./src/helpers/firebase.js